import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UsersRequestList, UsersRequest, UsersRemoveRoles, UsersAddRoles, UsersRequestSearch, UsersRequestStore } from '../../models/users/users.request.model';
import { UserResponse, UsersResponseTable } from '../../models/users/users.response.model';


@Injectable({ providedIn: 'root' })
export class UserService {

    constructor(private http: HttpClient) { }
    pathUrl:string = environment.backend.pathUrl.utenti.users;
    baseUrl: string = environment.backend.baseUrl_utenti;
    url: string = this.baseUrl + this.pathUrl;


    /**createParams
     * @param objectStoresParams 
     * @returns params
     * Prende in input un oggetto e lo trasforma in un HttpParams
     */
    createParams(objectStoresParams: any) {
        let params = new HttpParams();
        for (let property in objectStoresParams) {
            if (objectStoresParams.hasOwnProperty(property)) {
                params = params.append(property, objectStoresParams[property]);
            }
        }
        return params;
    }

    /**getList
     * @param request 
     * @returns Observable DocumentResponseList
     * 
     */
    getList(request: UsersRequestList): Observable<UsersResponseTable> {
        let url = this.url;
        let params = this.createParams(request);
        return this.http.get<UsersResponseTable>(url, { params: params });
    }

    create(request: UsersRequest): Observable<UserResponse> {
        let url = this.url;
        return this.http.post<UserResponse>(url, request);
    }

    getEntity(id: number): Observable<UserResponse> {
        let url = this.url + "/" + id;
        return this.http.get<UserResponse>(url);
    }

    update(id: number, request: UsersRequest): Observable<UserResponse> {
        let url = this.url + "/" + id;
        return this.http.put<UserResponse>(url, request);
    }

    delete(id: number) {
        let url = this.url + "/" + id;
        return this.http.delete<any>(url);
    }

    addPermission(id: number,request:UsersAddRoles): Observable<UserResponse>{
        let url = this.url + "/" + id + "/addRoles";
        return this.http.put<UserResponse>(url, request);
    }

    removePermission(id: number,request:UsersRemoveRoles): Observable<UserResponse>{
        let url = this.url + "/" + id + "/removeRoles";
        return this.http.put<UserResponse>(url, request);
    }

    store(id:number){
        let url = this.url + "/" + id + "/store";
        return this.http.get<any>(url);
    }


    search(request:UsersRequestSearch):Observable<UsersResponseTable>{
        let url = this.url+"/search";
        return this.http.post<UsersResponseTable>(url,request);
    }


    addStore(id: number,request:UsersRequestStore): Observable<UserResponse>{
        let url = this.url + "/" + id + "/addStore";
        return this.http.put<UserResponse>(url, request.listaStores);
    }

    removeStore(id: number,request:UsersRequestStore): Observable<UserResponse>{
        let url = this.url + "/" + id + "/removeStore";
        return this.http.put<UserResponse>(url, request.listaStores);
    }



}
